export default __webpack_public_path__ + "static/media/reaction-06.edef5dd5.svg";